
import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';
import OptimizedImage from '@/components/ui/optimized-image';

interface SidebarLogoProps {
  isCompact?: boolean;
}

const SidebarLogo: React.FC<SidebarLogoProps> = ({ isCompact = false }) => {
  // Logo is a critical element that needs to load quickly
  const logoSrc = "/lovable-uploads/5ff0c1a6-9b40-485d-bb61-6427fd6e304e.png";
  
  return (
    <div className="flex items-center justify-center pb-0 mb-4">
      <Link 
        to="/dashboard" 
        className={cn(
          "font-bold flex items-center",
          isCompact ? "justify-center" : "justify-center"
        )}
      >
        {isCompact ? (
          <OptimizedImage
            src={logoSrc}
            alt="Startup Fundraising"
            className="h-32 w-auto object-contain"
            width={144}
            height={144}
            priority={true}
            fetchPriority="high"
          />
        ) : (
          <OptimizedImage
            src={logoSrc}
            alt="Startup Fundraising"
            className="h-36 w-auto object-contain"
            width={160}
            height={160}
            priority={true}
            fetchPriority="high"
          />
        )}
      </Link>
    </div>
  );
};

export default SidebarLogo;
